<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="label"
        :placeholder="label"
        :outlined="outlined"
        :filled="filled"
        :hide-details="hideDetails"
        :value="dateView"
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      v-on:input="handleInput($event)"
      scrollable
    >
     <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        @click="modal = false"
      >
        Đóng lại
      </v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
  export default {
    name: 'CustomDatePicker',
    props: {
      value: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: 'Ngày'
      },
      outlined: {
        type: Boolean,
        default: false
      },
      filled: {
        type: Boolean,
        default: false
      },
      hideDetails: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        modal: false,
        date: null
      }
    },
    computed: {
      dateView: {
        get () {
          if(this.date != null){
            return this.parseDate(this.date);
          }
          return this.$props.value;
        },
        set (value) {
          this.$emit('change', value);
        }
      }
    },
    watch: {
      modal(){
        if(this.modal && this.$props.value){
          const [day, month, year] = this.$props.value.split('/');
          const pattern = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
          this.date = (new Date(pattern)).toISOString().substring(0,10);
        }
      }
    },
    methods: {
      parseDate (date) {
        if (!date) { return null };
        const [year, month, day] = date.split('-');
        return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
      },
      handleInput(content) {
        this.$emit("input", this.parseDate(content) );
        this.modal = false;
      }
    }
  }
</script>